import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

import { BaseScorecardComponent } from '../base/_base-scorecard.component';


@Component({
  moduleId: module.id,
  selector: 'overview-scorecard',
  templateUrl: 'overview-scorecard.component.html',
  styleUrls: ['overview-scorecard.component.scss'],
})
export class OverviewScorecardComponent extends BaseScorecardComponent {
  segmentTitle: string = 'Details';
  segmentsList: Array<any> = [
    {
      segment: 'details',
      url: 'item-details',
      title: 'Details',
    },
    {
      segment: 'descriptions',
      url: 'description',
      title: 'Description',
    },
    {
      segment: 'marketing',
      url: 'marketing',
      title: 'Market Copy',
    },
      {
      segment: 'fitments',
      url: 'fitments',
      title: 'Fitments',
    },
    {
      segment: 'prices',
      url: 'pricing',
      title: 'Pricing',
    },
    {
      segment: 'digitalAssets',
      url: 'digital-assets',
      title: 'Digital assets',
    },
    {
      segment: 'attributes',
      url: 'attributes',
      title: 'Attributes',
    },
    {
      segment: 'packages',
      url: 'packages',
      title: 'Packaging',
    },
    {
      segment: 'kits',
      url: 'kits',
      title: 'Kits',
    },
    {
      segment: 'interchanges',
      url: 'interchange',
      title: 'Interchange',
    },
  ];

  isValid(item: any): boolean {
    const score = this.getItemScore(item);
    if (!score) { return true; }
    return (score.possible === score.score);
  }

  getPossible(item: any): number {
    const score = this.getItemScore(item);
    return _.get(score, 'possible');
  }

  getScore(item: any): number {
    const score = this.getItemScore(item);
    return _.get(score, 'score');
  }

  getItemScore(item: any): any {
    return _.get(this.scoreData, `segments.${item.segment}`);
  }

  getInvalidCount(item): number|null {
    const possible = this.getPossible(item);
    const score = this.getScore(item);
    if (_.isNil(possible) || _.isNil(score)) { return null; }
    const invalidCount = possible - score;
    return !invalidCount ? null : invalidCount;
  }
}
